export default "__VITE_ASSET__CzvX17dE__"